const permissions = {
  pInstallation: {
    read: 'installation_read',
    write: 'installation_write',
    entityRead: 'installation_entity_read',
    entityWrite: 'installation_entity_write',
    configRead: 'installation_config_read',
    configWrite: 'installation_config_write',
    scenarioTrigger: 'installation_scenario_trigger',
    customerRead: 'installation_customer_read',
    customerWrite: 'installation_customer_write',
    planningRead: 'installation_planning_read',
    planningWrite: 'installation_planning_write',
  },
  pDevice: {
    read: 'device_read',
    write: 'device_write',
  },
  pAdmin: 'admin',
  pCallback: 'callback',
  pCpm: {
    accesses: 'accesses',
    bookingRead: 'booking_r',
    bookingSettingsWrite: 'booking_settings_w',
    bookingWrite: 'booking_w',
    cancelBooking: 'cancel_booking',
    connectedEquipmentRead: 'connected_equipments_r',
    configurationRead: 'configuration_r',
    configurationWrite: 'configuration_w',
    configurationSensitiveRead: 'configuration_sensitive_r',
    configurationSensitiveWrite: 'configuration_sensitive_w',
    customerRead: 'customer_r',
    customerWrite: 'customer_w',
    invoiceRead: 'invoice_r',
    metricsAccesses: 'metrics_accesses',
    metricsOccupancyRate: 'metrics_occupancy_rate',
    metricsRevenues: 'metrics_revenues',
    licensePlateDelaySettingsRead: 'license_plate_delay_settings_r',
    licensePlateDelaySettingsWrite: 'license_plate_delay_settings_w',
    parkingPriceDiscountWrite: 'parking_price_discount_w',
    parkingRead: 'parking_r',
    parkingWrite: 'parking_w',
    parkingCategoryRead: 'parking_category_r',
    parkingCategoryWrite: 'parking_category_w',
    parkingCategoryPriceGridWrite: 'parking_category_price_grid_w',
    priceGridRead: 'price_grid_r',
    priceGridWrite: 'price_grid_w',
    planningRead: 'planning_r',
    planningWrite: 'planning_w',
    onDemandAccessSettingsWrite: 'on_demand_access_settings_w',
    onDemandRead: 'on_demand_access_r',
    onDemandWrite: 'on_demand_access_w',
    triggerDoor: 'trigger_door',
    refund: 'refund',
    management:
    'accesses||configuration_r||configuration_w||customer_r||customer_w||metrics_accesses||metrics_occupancy_rate||metrics_revenues||parking_price_discount_w||parking_r||parking_w||planning_r||planning_w||trigger_door||parking_category_r||parking_category_w||parking_category_price_grid_w||price_grid_r||price_grid_w||on_demand_access_r||on_demand_access_w||refund',
  },
  pBooking: {
    bookings: 'bookings',
  },
  pSupport: {
    bookingResendConfirmationEmail: 'booking_resend_confirmation_email',
    carparkContactUpdate: 'carpark_contact_update',
    invoiceUpdate: 'invoice_update',
    onDemandAccessCheckout: 'on_demand_access_checkout',
    onDemandAccessSetBegin: 'on_demand_access_set_begin',
    onDemandAccessTerminate: 'on_demand_access_terminate',
    onDemandAccessUpdate: 'on_demand_access_update',
    priceGridSendToCustomer: 'price_grid_send_to_customer',
    parkingGlobalCarpark: 'parking_global_carpark',
  },
  pFeature: {
    accounts: 'accounts',
    bookings: 'bookings',
    carparks: 'carparks',
    admin: 'admin',
  },
  pAccountsManagement: {
    accountRead: 'account_r',
    accountWrite: 'account_w',
  },
};

export default permissions;



// WEBPACK FOOTER //
// ./constants/Permissions.js